import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { ReceiptSearchService } from '../data-access/receipt-search.service';
import { ReceiptLookupNavigationService } from '@kempower-nx-workspace/receipt-lookup-app-core';
import { ConfigService } from '@kempower-nx-workspace/receipt-lookup-environment';
import { buildSessionStorageKey } from '../utils/session-storage-utils';

export const resultsGuard: CanActivateFn = (route, state) => {
    const navigationService = inject(ReceiptLookupNavigationService);
    const configService = inject(ConfigService);

    const SEARCH_RESULTS_KEY = buildSessionStorageKey(
        configService.extractedCustomerId,
        ReceiptSearchService.STORAGE_KEYS.RECEIPT_SEARCH_RESULTS
    );
    const SEARCH_JUST_COMPLETED_KEY = buildSessionStorageKey(
        configService.extractedCustomerId,
        ReceiptSearchService.STORAGE_KEYS.SEARCH_JUST_COMPLETED
    );

    const hasValidResults = () => {
        const searchJustCompleted = sessionStorage.getItem(SEARCH_JUST_COMPLETED_KEY);

        if (searchJustCompleted) {
            sessionStorage.removeItem(SEARCH_JUST_COMPLETED_KEY);
            return true;
        }

        try {
            const stored = localStorage.getItem(SEARCH_RESULTS_KEY);

            if (stored) {
                const parsed = JSON.parse(stored);
                const hasData = !!(parsed.data && parsed.data.length > 0);
                return hasData;
            }
        } catch (error) {
            console.error('Error checking stored results:', error);
        }

        return false;
    };

    const result = hasValidResults();

    if (!result) {
        navigationService.navigateToSearchRoot();
        return false;
    }

    return true;
};
